export const data = {


    scene: '03_walk_ok',
    kysymysteksti: 'Kyllä, 3-pistekävely sopii tähän tilanteeseen!',

    optiot: []


};